import { addEventListener } from './utils';
import { getLinkClickEventProperties } from '@squareup/public-web-browser-helpers/cdp-formatter';

const CTA_LINK_TRACKING_REGEX = new RegExp(
  [
    // logic for optional sections in url
    '^((',
    // protocol
    'http(s)?:\\/\\/',
    ')?',
    // domain
    'squareup(staging)?\\.com',
    ')?',
    // locale prefix
    '(',
    '\\/[a-z]{2}\\/[a-z]{2}',
    ')?',
    // cta links that appear after optional sections above
    '(',
    ['\\/signup', '\\/dashboard\\/', '\\/login\\?return_to=', '\\/gift-cards\\/pricing'].join('|'),
    ')|',

    // optional protocol logic for onelink.me links
    '^(?:https:\\/\\/)?',
    '(',
    ['go\\.onelink\\.me', 'square-register\\.onelink\\.me'].join('|'),
    ')|',

    // this match string appears as a query parameter
    // in the middle of the link, not at the start
    '(\\?|&)route=%2Fsignup',
  ].join('')
);

const ctaLinkTrackingHelper = {
  permissions: {} as InitializationProperties,

  clickEventHandler: (event: Event) => {
    const target = event.target;
    let properties;
    const linkProperties = getLinkClickEventProperties(event);
    if (linkProperties !== undefined) {
      properties = linkProperties.cdpProperties;
    }
    if (target instanceof Element) {
      const ctaLink = target.getAttribute('href');
      if (ctaLink && ctaLink.match(CTA_LINK_TRACKING_REGEX) !== null) {
        window.Sq.Tracking.track(
          {
            action: 'Click Conversion CTA',
            properties,
          },
          { destinations: ['cdp'] }
        );
      }
    }
  },
  attachEventListener: () => {
    const pageElement: HTMLElement = document.getElementById('page') as HTMLElement;
    addEventListener(pageElement, 'click', ctaLinkTrackingHelper.clickEventHandler, 'a[href]');
  },

  initialize: (permissions: InitializationProperties): Promise<void> => {
    ctaLinkTrackingHelper.permissions = permissions;
    return new Promise((resolve) => {
      ctaLinkTrackingHelper.attachEventListener();
      resolve();
    });
  },
};

export default ctaLinkTrackingHelper;
